import { relationGroupsConstants } from '../../_constants';
import { relationGroupsService } from '../../_services';
import { relationGroupsTableActions } from './relationGroupsTable.actions';

export const editRelationGroup = {
    addData
};

function addData(id,data) {
    return dispatch => {
        dispatch(request(data));
        relationGroupsService.editRelationGroup(id,data)
            .then(
                relationGroup => {
                    dispatch(relationGroupsTableActions.getRelationGroups())
                    dispatch(success(relationGroup));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(data) { return { type: relationGroupsConstants.REQUEST_EDIT_RELATION_GROUP,data} }
    function success(relationGroup) { return { type: relationGroupsConstants.RECEIVE_EDIT_RELATION_GROUP, relationGroup } }
    function failure(error) { return { type: relationGroupsConstants.EDIT_RELATION_GROUP_ERROR, error } }
}



// WEBPACK FOOTER //
// ./src/_actions/relationGroups/editRelationGroup.action.js